module.exports = __webpack_public_path__ + "img/H2.12a78828.png";